<template>
  <div>
    <el-dialog
      title="Dönem Detay"
      :visible="Modal"
      center
      width="70%">

      <a @click="$emit('BinaDonemDetayModal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>

      <el-form :model="FormData" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="Dönem Başlangıç Tarihi" prop="basTarihi">
              <el-date-picker
                v-model="FormData.basTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Dönem Süresi (AY)" prop="ay">
              <el-input-number v-model="FormData.ay" :precision="0" :step="1" :min="2"
                               :max="24"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="Tooltip" label="Genel Kurul Tarihi" prop="GKTarihi">
              <el-tooltip class="item" effect="dark"
                          content="Karar Defteri Genel Kurul Tarihi"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-date-picker
                v-model="FormData.KararDefteri.GKTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="Tooltip" label="Onay Tarihi" prop="OTarihi">
              <el-tooltip class="item" effect="dark"
                          content="Karar Defterinin Onay Tarihi"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-date-picker
                v-model="FormData.KararDefteri.OTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="Tooltip" label="Noter Adı" prop="Noter">
              <el-tooltip class="item" effect="dark"
                          content="Karar Defterini onaylayan Noter Bilgisi"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input v-model="FormData.KararDefteri.Noter"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Yevmiye No" prop="yNo">
              <el-tooltip class="item" effect="dark"
                          content="Karar Defteri Yevmiye No"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input v-model="FormData.KararDefteri.yNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Karar Defteri Sayfa No" prop="KSNo">
              <el-tooltip class="item" effect="dark"
                          content="Yönetimin yetki aldığı karar defteri sayfa numarası"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input v-model="FormData.KararDefteri.KSNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Aidat Bedeli" prop="Borclandirma">
              <el-tooltip class="item" effect="dark"
                          content="Kararlaştırılmış aidat bedeli"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input v-model="FormData.Borclandirma"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="Yönetici Ad Soyad" prop="Yonetici">
              <el-input v-model="FormData.Yonetim.Yonetici"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Vekil Ad Soyad" prop="Vekil">
              <el-input v-model="FormData.Yonetim.Vekil"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Denetçi Ad Soyad" prop="Denetci">
              <el-input v-model="FormData.Yonetim.Denetci"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Üye Ad Soyad" prop="Uye">
              <el-input v-model="FormData.Yonetim.Uye"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="17.Özel Madde İçeriği" prop="OzelMadde">
              <el-input type="textarea" v-model="FormData.KararDefteri.OzelMadde"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <IsletmeProjesi @Proje="Proje($event)" :Adet="BinaBilgi.Mesken.Adet" :Toplam="BinaBilgi.Mesken.Toplam"
                      :Sure="FormData.ay" :Proje="FormData.Proje"></IsletmeProjesi>


      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()" icon="el-icon-check">
          {{ $t('eGenel.0') }}
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import IsletmeProjesi from "../../../Genel/IsletmeProjesi";


export default {
  props: ["Modal", "Donem", "BinaBilgi"],
  components: {IsletmeProjesi },
  data() {
    return {
      FormData: null,
      FormHata: {
        Borclandirma: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        basTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        ay: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
    }
  },
  methods: {
    Proje(veri) {
      this.FormData.Proje = veri;
    },
    Submit() {
      //this.FormData.Bina_id = this.BinaBilgi.id;
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          if (this.FormData.id) {
            // DÜZENLE
            this.$store.dispatch("Put", {
              ...this.FormData,
              path: 'yonetim/bina/donem/' + this.FormData.id
            })
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit("BinaDonemDetayModal", false);
                  this.$message.success(response.Mesaj);
                  //location.reload()
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })

          } else {
            // EKLE
            this.$store.dispatch("Post", {...this.FormData, path: 'yonetim/bina/donem'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit("BinaDonemDetayModal", false);
                  this.$message.success(response.Mesaj);
                  //this.$router.push('/yonetim/bina')
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        }
      });

    },
    SayfaYukle() {
      if (this.Donem) {
        this.FormData = this.Donem;
      } else {
        this.FormData = {
          Proje: null,
          Bina_id: this.BinaBilgi.id,
          basTarihi: null,
          ay: null,
          Yonetim: {
            Yonetici: null,
            Vekil: null,
            Denetci: null,
            Uye: null,
          },
          KararDefteri: {
            GKTarihi: null,
            OzelMadde: '',
            OTarihi: null,
            Noter: null,
            yNo: null,
            KSNo: null
          }
        }
      }
    }
  },
  created() {
    this.SayfaYukle();
  },
  computed: {
    rSAyfaYukle() {
      return this.Donem
    },
  },
  watch: {
    rSAyfaYukle() {
      this.SayfaYukle();
    },
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaDonemDetay.vue